var map = {
	"./30/images/swipe-dark.svg": "83d7",
	"./75/images/logo_svg.svg": "084c",
	"./77/images/Pattern-primary.svg": "0dae",
	"./77/images/Pattern-secondary.svg": "6813",
	"./77/images/attention.svg": "da53",
	"./77/images/cross.svg": "d9b8",
	"./77/images/cross_themeAccent.svg": "afe7",
	"./77/images/down-arrow.svg": "7c66",
	"./77/images/help.svg": "fc3e",
	"./77/images/logo.svg": "7a14",
	"./77/images/minus.svg": "e468",
	"./77/images/new-window.svg": "f3e7",
	"./77/images/plus.svg": "1021",
	"./77/images/rebrand_ui.svg": "a7e7",
	"./77/images/tick.svg": "ec6e",
	"./9/images/logo-white.svg": "e459"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "d5b2";